import { Fragment, useState } from 'react';
import { Listbox, Transition } from '@headlessui/react';

function FormLabel(props) {
  return (
    <div
      className={`${
        props.name === 'password' || props.name === 'passwordConfirm'
          ? 'md:h-10'
          : null
      } ${props.name === 'industry' && 'text-2xl'}`}
    >
      <label className='font-semibold mb-1.5 mr-1 block z-10 whitespace-normal leading-4 text-small'>
        {props.labelText}{' '}
        {props.required && <span className='text-red-600'>*</span>}
      </label>
    </div>
  );
}

function FormInput(props) {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div
      className={` ${
        props.errorMessage ? 'pl-3 border-l-2 border-red-700' : ''
      } ${
        props.type === 'password' ||
        props.type === 'passwordConfirm' ||
        props.type === 'search' ||
        (props.errorMessage && props.type === 'password') ||
        (props.errorMessage && props.type === 'passwordConfirm') ||
        (props.errorMessage && props.type === 'search')
          ? 'relative'
          : null
      }`}
    >
      <FormLabel
        labelText={props.labelText}
        type={props.type}
        optional={props.optional}
        validated={props.validated}
        errorMessage={props.errorMessage}
        required={props.required}
      />
      {props.hint && (
        <p
          className='pt-0 pl-0 mb-1.5 pb-0 font-light font-sans'
          dangerouslySetInnerHTML={{ __html: props.hint }}
        />
      )}
      {props.errorMessage ? (
        <p
          className='mb-1.5 br-1 p-0 text-red-700'
          dangerouslySetInnerHTML={{ __html: props.errorMessage }}
        />
      ) : (
        <p className='mb-0 br-0 p-0'>{''}</p>
      )}
      {props.type === 'search' && props.filtering && (
        <svg
          height='24'
          width='24'
          fill='none'
          viewBox='0 0 24 24'
          stroke='currentColor'
          className={`animate-spin text-blue-500 absolute left-2 bottom-2 inline-flex`}
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15'
          />
        </svg>
      )}
      {props.type === 'password' && (
        <svg
          fill='none'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          stroke='currentColor'
          className={`absolute ${
            props.errorMessage ? 'left-5' : 'left-3'
          } bottom-0 transform -translate-y-2 text-gray-400`}
          onClick={(e) => setShowPassword(!showPassword)}
        >
          {!showPassword ? (
            <>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M15 12a3 3 0 11-6 0 3 3 0 016 0z'
              />
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z'
              />
            </>
          ) : (
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21'
            />
          )}
        </svg>
      )}
      <input
        className={`${
          props.errorMessage && 'border-red-700 focus:border-red-700 '
        } w-full sm:w-96 border border-coolGray-300 focus:ring-0 focus:border-blue-400 text-coolGray-600 font-medium bg-transparent rounded z-10 ${
          props.name === 'password' ||
          props.name === 'confirmPassword' ||
          props.filtering
            ? 'pl-10'
            : null
        }`}
        type={
          props.type === 'password'
            ? !showPassword
              ? 'password'
              : 'text'
            : props.type
        }
        aria-label='form input'
        placeholder={props.placeHolderText}
        value={props.value}
        name={props.name}
        onChange={props.onChange}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        autoComplete={props.type === 'password' ? 'new-password' : 'off'}
      />
      {props.type === 'search' && props.schoolListVisible ? (
        <div className='w-full sm:w-96 absolute top-50 left-0 h-auto overflow-hidden shadow-lg rounded-lg bg-white z-50'>
          <div className='h-full w-full max-h-40 overflow-y-auto flex flex-col'>
            {props.filteredSchoolList.map((school) => {
              const { id, name } = school;
              return (
                <div
                  onClick={props.selectSchoolFromList}
                  id={id}
                  className='bg-white p-2 items-center hover:bg-blue-500 hover:text-white hover:font-bold'
                  key={id}
                >
                  {name}
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
}

function FormItemContainer(props) {
  return (
    <Fragment>
      <FormLabel labelText={props.labelText} required={props.required} />
      {props.hint && (
        <p className='pt-0 pl-0 pb-1 font-light font-sans w-96'>{props.hint}</p>
      )}
      <div className='flex flex-col p-1'>{props.children}</div>
    </Fragment>
  );
}

function FormRadioItem(props) {
  return (
    <div className='flex items-center p-2 py-1'>
      <input
        className='focus:ring-1 focus:ring-sky-500 focus:outline-none text-sm text-dms-primary p-2'
        type={props.type}
        aria-label='text input'
        placeholder={props.placeholderText}
        checked={props.checked}
        value={props.value}
        name={props.name}
        onChange={props.onChange}
      />
      <span className='mx-2 text-coolGray-700'>{props.spanText}</span>
    </div>
  );
}

function FormCheckItem(props) {
  return (
    <div
      className={`${props.disabled ? 'opacity-25' : null}`}
      disabled={props.disabled}
    >
      <input
        className={`focus:border-light-lightBlue-500 focus:ring-1 focus:ring-lightlightBlue-500 focus:outline-none text-sm text-black placeholder-gray-500border-none rounded-md p-2 shadow-md`}
        type={props.type}
        aria-label='text input'
        placeholder={props.placeholderText}
        value={props.value}
        name={props.name}
        checked={props.checked}
        onChange={props.onChange}
      />
      <span className='mx-2 text-blueGray-800'>{props.spanText}</span>
    </div>
  );
}

function FormListBox(props) {
  let items = ['1', '2', '3', '4', '5'];
  if (props.items) {
    items = props.items;
  }
  const [selectedItem, setSelectedItem] = useState(items[0]);
  return (
    <div>
      <Listbox
        as='div'
        className='space-y-1'
        value={selectedItem}
        onChange={setSelectedItem}
      >
        {({ open }) => (
          <>
            <Listbox.Label className='text-lg font-light my-3 whitespace-nowrap'>
              {props.labelText}
            </Listbox.Label>
            <div className='relative'>
              <span className='inline-block w-full rounded-md shadow-sm'>
                <Listbox.Button className='cursor-default relative w-full rounded-md bg-white pl-3 pr-10 py-2 text-left focus:outline-none focus:shadow-outline-blue focus:border-lightBlue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5 shadow-md'>
                  <span className='block truncate'>{selectedItem}</span>
                  <span className='absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none'>
                    <svg
                      className='h-5 w-5 text-gray-400'
                      viewBox='0 0 20 20'
                      fill='none'
                      stroke='currentColor'
                    >
                      <path
                        d='M7 7l3-3 3 3m0 6l-3 3-3-3'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  </span>
                </Listbox.Button>
              </span>

              <Transition
                show={open}
                leave='transition ease-in duration-100'
                leaveFrom='opacity-100'
                leaveTo='opacity-0'
                className='absolute mt-1 w-full rounded-md bg-white shadow-lg z-10'
              >
                <Listbox.Options
                  static
                  className='max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5'
                >
                  {items.map((item) => (
                    <Listbox.Option key={item} value={item}>
                      {({ selected, active }) => (
                        <div
                          className={`${
                            active
                              ? 'text-white bg-lightBlue-500'
                              : 'text-gray-900'
                          } cursor-default select-none relative py-2 pl-8 pr-4`}
                        >
                          <span
                            className={`${
                              selected ? 'font-semibold' : 'font-normal'
                            } block truncate`}
                          >
                            {item}
                          </span>
                          {selected && (
                            <span
                              className={`${
                                active ? 'text-white' : 'text-lightBlue-600'
                              } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                            >
                              <svg
                                className='h-5 w-5'
                                xmlns='http://www.w3.org/2000/svg'
                                viewBox='0 0 20 20'
                                fill='currentColor'
                              >
                                <path
                                  fillRule='evenodd'
                                  d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                  clipRule='evenodd'
                                />
                              </svg>
                            </span>
                          )}
                        </div>
                      )}
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </Transition>
            </div>
          </>
        )}
      </Listbox>
    </div>
  );
}

function FormSelect(props) {
  return (
    <Fragment>
      <FormLabel labelText={props.labelText} />
      <select
        className='focus:border-light-lightBlue-500 focus:ring-1 focus:ring-lightlightBlue-500 focus:outline-none w-full text-sm text-black placeholder-gray-500 border-none rounded-md p-2 shadow-md'
        aria-label='form input'
        placeholder={props.placeHolderText}
        value={props.value}
        name={props.name}
        onChange={props.onChange}
        multiple={props.multiple}
      >
        <FormSelectItem value='1' text='1' />
        <FormSelectItem value='2' text='2' />
        <FormSelectItem value='3' text='3' />
        <FormSelectItem value='4' text='4' />
        <FormSelectItem value='5' text='5' />
      </select>
    </Fragment>
  );
}

function FormSelectItem(props) {
  return (
    <Fragment>
      <option value={props.value}>{props.text}</option>
    </Fragment>
  );
}

function FormTextArea(props) {
  return (
    <Fragment>
      <FormLabel labelText={props.labelText} />
      <textarea
        className='focus:border-light-lightBlue-500 focus:ring-1 focus:ring-lightlightBlue-500 focus:outline-none w-full text-sm text-black placeholder-gray-500 border-none rounded-md p-2 shadow-md'
        aria-label='form input'
        placeholder={props.placeHolderText}
        value={props.value}
        name={props.name}
        onChange={props.onChange}
      />
    </Fragment>
  );
}

export {
  FormInput,
  FormItemContainer,
  FormRadioItem,
  FormCheckItem,
  FormSelect,
  FormSelectItem,
  FormTextArea,
  FormListBox,
  FormLabel,
};
